import { HrParms, HttpGeneralService } from '../../shared';
import { CONFIG } from './../../shared/config';
import { Injectable } from '@angular/core';
import { HrVacationRequest } from '../personnel-stp.interfaces';

let hrUrl = CONFIG.baseUrls.hr;


@Injectable()
export class RequestsListService {
  constructor(private httpGeneralService: HttpGeneralService) { }

  updateStatusAndSentRequest(hrParms: HrParms) {
   return this.httpGeneralService.add(hrParms, `${hrUrl}/updateStatusAndSentRequest`)
  }


  UpdateAlert(hrParms: HrParms) {
    return this.httpGeneralService.add(hrParms, `${hrUrl}/updateStatusAndSentRequestUpadte`)
   }

  updateRequestList(_HrVacationRequest: HrVacationRequest) {
    return this.httpGeneralService.add(_HrVacationRequest, `${hrUrl}/updateRequestList`)
  }

  //getRequestBalance(hrParms: HrParms) {
  //  return this.httpGeneralService.add(hrParms, `${hrUrl}/GetRequestBalance`)
  //}

  getRequestListData(hrParms: HrParms) {
    return this.httpGeneralService.add(hrParms, `${hrUrl}/getRequestListData`)
  }

  //deleteVacationRequest(_HrVacationRequest: HrVacationRequest) {
  //  return this.httpGeneralService.add(_HrVacationRequest,`${hrUrl}/deleteVacationRequest`)
  //}
  getApproverOrnotApprovedReq() {
   return this.httpGeneralService.getWith( `${hrUrl}/getApproverOrnotApprovedReq`);
  }

  

  updateRequestStatus(hrParms: HrParms) {
    return this.httpGeneralService.add(hrParms, `${hrUrl}/updateRequestStatus`);
   }
}
